import { render, staticRenderFns } from "./TicketCommentSelf.vue?vue&type=template&id=1767fae8&scoped=true"
import script from "./TicketCommentSelf.vue?vue&type=script&lang=ts"
export * from "./TicketCommentSelf.vue?vue&type=script&lang=ts"
import style0 from "./TicketCommentSelf.vue?vue&type=style&index=0&id=1767fae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1767fae8",
  null
  
)

export default component.exports